export const kameleoonBaseScript =
  'window.kameleoonQueue = window.kameleoonQueue || []';

export const kameleoonAntiFlickeringScript = ({
  loadingTimeout = 1000,
}: { loadingTimeout?: number } = {}): string => `
var kameleoonLoadingTimeout = ${loadingTimeout};
window.kameleoonQueue = window.kameleoonQueue || [];
window.kameleoonStartLoadTime = new Date().getTime();
if(!document.getElementById("kameleoonLoadingStyleSheet") && !window.kameleoonDisplayPageTimeOut){
  var kameleoonS = document.getElementsByTagName("script")[0];
  var kameleoonCc = "*{visibility:hidden!important;background-image:none!important;}";
  var kameleoonStn = document.createElement("style");
  kameleoonStn.type = "text/css";
  kameleoonStn.id = "kameleoonLoadingStyleSheet";
  if(kameleoonStn.styleSheet){
    kameleoonStn.styleSheet.cssText = kameleoonCc;
  } else {
    kameleoonStn.appendChild(document.createTextNode(kameleoonCc));
  }
  kameleoonS.parentNode.insertBefore(kameleoonStn, kameleoonS);
  window.kameleoonDisplayPage = function(fromEngine){
    if(!fromEngine) window.kameleoonTimeout = true;
    if(kameleoonStn.parentNode) kameleoonStn.parentNode.removeChild(kameleoonStn);
  };
  window.kameleoonDisplayPageTimeOut = window.setTimeout(window.kameleoonDisplayPage, kameleoonLoadingTimeout);
}
`;

export const kameleoonIframeSetupScript = ({
  iframeUrl,
}: { iframeUrl: string }): string => {
  return `
    window.kameleoonIframeURL = "${iframeUrl}";
    window.kameleoonLightIframe = false;
    var kameleoonIframeOriginElement = document.createElement("a");
    kameleoonIframeOriginElement.href = kameleoonIframeURL;
    window.kameleoonIframeOrigin = kameleoonIframeOriginElement.origin || (kameleoonIframeOriginElement.protocol + "//" + kameleoonIframeOriginElement.hostname);
    if (location.href.indexOf(window.kameleoonIframeOrigin) != 0)
    {
        window.kameleoonLightIframe = true;
        var kameleoonProcessMessageEvent = function(event)
        {
            if (window.kameleoonIframeOrigin == event.origin && event.data.slice && event.data.slice(0,9) == "Kameleoon")
            {
                window.removeEventListener("message", kameleoonProcessMessageEvent);
                window.kameleoonExternalIFrameLoaded = true;
                if (window.Kameleoon)
                {
                    Kameleoon.Utils.runProtectedScript(event.data);
                    Kameleoon.Analyst.load();
                }
                else
                {
                    window.kameleoonExternalIFrameLoadedData = event.data;
                }
            }
        };
        if (window.addEventListener)
        {
            window.addEventListener("message", kameleoonProcessMessageEvent, false);
        }
        var iframeNode = document.createElement("iframe");
        iframeNode.src = kameleoonIframeURL;
        iframeNode.id = "kameleoonExternalIframe";
        iframeNode.style = "float: left !important; opacity: 0.0 !important; width: 0px !important; height: 0px !important;";
        document.head.appendChild(iframeNode);
    }
`;
};
